import notFoundPanoramicImage1 from '@/assets/not-found-panoramic-image-1.webp'
import notFoundPanoramicImage2 from '@/assets/not-found-panoramic-image-2.webp'
import notFoundPanoramicImage3 from '@/assets/not-found-panoramic-image-3.webp'

/** Imágenes de respaldo cuando no hay ninguna imagen real disponible —
 * varias, no una sola, para poder repartirlas alternadas entre distintos
 * elementos sin repetir siempre la misma. Import estático: pasa por el
 * pipeline de assets de Next.js (hash + `assetPrefix`), sin depender de la
 * convención manual de rutas `/entradas/...` de `public/`
 * (`architecture.rule.md`). Compartida por `HeroCarousel` (round-robin entre
 * los elementos que la necesitan) y `Video` (reparto por posición —
 * `specs/040-video-module/research.md` §6). */
export const FALLBACK_IMAGES = [
  notFoundPanoramicImage1.src,
  notFoundPanoramicImage2.src,
  notFoundPanoramicImage3.src,
]
